import { call, put, takeLatest } from 'redux-saga/effects';
import Api from '../api';
import _ from 'lodash';


function* listPackages( action )
{
    try
    {
        const opts = action.opts;

        const list = yield call(
            Api.listPackages,
            _.get( opts, 'packageFilter', null ),
            _.get( opts, 'type', null ),
            _.get( opts, 'channel', null ),
            _.get( opts, 'signature', null )
        );

        yield put( { type: 'PACKAGE_LIST_SUCCEEDED', list : list } );
    }
    catch( e )
    {
        console.error( e );
        yield put( { type: 'PACKAGE_LIST_FAILED', message: e.message } );
    }
}


function* mySaga()
{
    yield takeLatest( 'PACKAGE_LIST_REQUESTED', listPackages );
}

export default mySaga;




// WEBPACK FOOTER //
// ./src/lib/sagas/list-packages.js